<section *ngIf="pdpStaticContent && deviceDetails">
  <div class="row">
    <div class="col-4 m-t-xl">
      <a
        href="javascript:void(0);"
        attr.aria-label="{{ deviceDetails?.familyName }}"
        id="cta-family-name-4"
      >
        <img
          class="img-fluid"
          [src]="extTmoImagesUrl + selectedItem?.mainImageUrl"
          alt="{{ deviceDetails?.familyName }}"
        />
      </a>
    </div>
    <div class="col-8">
      <form [formGroup]="accessoriesOfferingsFormGroup">
        <h4 class="m-t-xl">{{ deviceDetails?.familyName }}</h4>
        <!-- <div class="m-t-lg">
              <p class="small" *ngIf="isAssistedFlow">
                ({{pdpStaticContent?.sku}}:{{selectedItem?.id}})</p>
            </div> -->

        <div
          *ngIf="!selectedItem?.hasSale && selectedItem?.hasDeal && selectedItem?.promotions"
          class="row m-l-xl m-t-sm"
        >
          <div class="col-12">
            <div class="badge-magenta out-left m-r-xs">
              <p class="legal">{{ pdpStaticContent?.dealEnd }}</p>
            </div>
            <a
              href="javascript:void(0)"
              [innerHtml]="selectedItem?.promotions[0]?.promoName"
              (click)="showPromotionalModal(0)"
              id="cta-default-5"
            ></a>
          </div>
        </div>
        <tmo-devices-pricing-panel
          [deviceAmount]="selectedItem?.productPrice"
          [id]="deviceDetails?.familyName"
        >
          <ng-container
            *ngIf="selectedItem?.hasSale || (selectedItem?.hasSale && selectedItem?.hasDeal)"
          >
            <div class="badge-magenta m-r-sm m-l-lg m-t-sm">
              <p class="legal">
                {{ pdpStaticContent?.sale }}
              </p>
            </div>
            <p class="m-t-lg sm-m-b-lg">{{ savedAmountText }}</p>
            <div class="col-12">
              <h5 class="md-m-l-lg md-m-t-lg price-text n3 inline-block">
                <sup class="n4">$</sup><s>{{ listPriceWholeNumber }}</s
                ><sup class="n4">{{ listPriceDecimalNumber }}</sup>
              </h5>
            </div>
          </ng-container>
        </tmo-devices-pricing-panel>

        <div class="row m-t-lg" *ngIf="!isExistingLine">
          <div class="col-12">
            <!--Promotions start-->
            <div *ngIf="selectedItem?.hasDeal && selectedItem?.promotions">
              <div *ngFor="let promotion of selectedItem?.promotions; let promoIndex = index">
                <div *ngIf="promoIndex > 0 && !selectedItem?.hasSale">
                  <a
                    href="javascript:void(0);"
                    [innerHtml]="promotion?.promoName"
                    (click)="showPromotionalModal(promoIndex)"
                    id="cta-default-595_{{ promoIndex }}"
                    >{{ promotion?.promoName }}</a
                  >
                </div>
                <div *ngIf="selectedItem?.hasSale">
                  <a
                    href="javascript:void(0)"
                    [innerHtml]="promotion.promoName"
                    (click)="showPromotionalModal(promoIndex)"
                    id="cta-default-6_{{ promoIndex }}"
                    >{{ promotion?.promoName }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <p class="lead bold m-t-md" [innerHtml]="pdpStaticContent?.inStock"></p>
          </div>
        </div>

        <div class="row m-t-lg">
          <div class="col-1 m-t-sm m-r-lg">
            <p class="small inline-block">{{ pdpStaticContent?.qty }}</p>
          </div>
          <div class="col-4 col-lg-3" *ngIf="qtyList">
            <tmo-dropdown
              name="'qty'"
              [options]="qtyList"
              [focusFirstElement]="true"
              formControlName="qty"
              [(ngModel)]="selectedQuantity"
              (selectionChange)="onUpdateQty(qty)"
              [id]="'tmo-dropdown-qty-3'"
            >
            </tmo-dropdown>
          </div>
        </div>
        <div class="row">
          <div class="col-12 sm-4 col-sm-8">
            <hr class="divider m-t-xl" />
            <h5 class="m-b-lg m-t-lg">{{ pdpStaticContent?.color }}</h5>
            <span class="color-radio" *ngFor="let item of colorOptions; let ind = index">
              <input
                type="radio"
                name="color-radio_sample"
                aria-label="Radio"
                [value]="item?.name"
                [checked]="selectedItem?.color === item?.name"
                attr.aria-label="{{ pdpStaticContent?.color }} {{ item.name }}"
                (click)="updateSelectedColor(item?.name)"
                id="btn-radio-colorradiosample_{{ ind }}"
              />
              <span class="img-color">
                <img
                  [src]="extTmoImagesUrl + item.imagePath"
                  class="bg-gray-light"
                  alt="Item Image"
                />
                <p class="xsmall">{{ item.name }}</p>
              </span>
            </span>
          </div>
        </div>
        <hr class="divider m-t-xl" />
        <div class="row">
          <div class="col-12 buttons-container-vertical button-spacing">
            <div class="button-box">
              <button
                class="btn btn-primary"
                (click)="addAccessoriesToCart(false)"
                [innerHtml]="pdpStaticContent?.addToCart"
                id="btn-default-6"
              ></button>
            </div>
            <div class="button-box">
              <button
                class="btn btn-secondary"
                (click)="addAccessoriesToCart(true)"
                [innerHtml]="pdpStaticContent?.checkout"
                id="btn-default-7"
              ></button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
<tmo-dynamic-modal [modal]="modal" (onHide)="closeModal()">
  <ng-container header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i>
      <a
        tabindex="0"
        [attr.aria-label]="pdpStaticContent?.clickToClose"
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeModal()"
        id="cta-click-to-close-4"
      >
        <i class="fa fa-times"></i
      ></a>
    </div>
    <div class="row">
      <div class="col-12">
        <h3>{{ deviceDetails?.familyName }}</h3>
      </div>
    </div>
  </ng-container>
  <p class="small m-t-md">{{ promoDescription?.shortDescription }}</p>
  <p class="small m-t-md">{{ promoDescription?.longDescription }}</p>
</tmo-dynamic-modal>
